import { connect } from 'react-redux';
import { IAppState } from '../../../common/state';
import { offerTypeFromJsonQuery } from '../../../utils/category';
import { getBannerLocation } from '../../../utils/demand/getBannerLocation';
import { OfferTypeLabel, RoomsLabel } from './constants';
import { Trap, ITrapProps } from './Trap';
import { getCity, getName } from '../../../utils/demand';
import {
  demandCloseSuccessModalAction,
  demandRequestCreateMessageStartAction,
  demandShowSuccessModal,
} from '@cian/demand-trap-widget';
import { sendTeaserEvent, ITeaserEventProps } from '../../../../browser/utils/TeaserEvent';
import { withObservation } from '@cian/component-observer';

type TActions = Pick<ITrapProps, 'demandRequestCreateMessageStartAction' | 'demandCloseSuccessModalAction'>;

export const mapStateToProps = (state: IAppState) => {
  const { user, filters, config, results, soprApi } = state;
  const { offers, suggestions, jsonQuery: resultJsonQuery } = results;
  const { jsonQuery, currentLocation } = filters;
  const firstName = user && user.isAuthenticated ? user.firstName : '';
  const lastName = user && user.isAuthenticated ? user.lastName : '';
  const offersPerPage = config.get<number>('serp.offersPerPage') || 0;
  const dealType = jsonQuery._type.endsWith('sale') ? 'sale' : 'rent';
  const realtyCategory = jsonQuery._type.startsWith('commercial') ? 'commercial' : 'flat';
  const realtyType = OfferTypeLabel[offerTypeFromJsonQuery(jsonQuery)] || 'other';
  const roomCount = jsonQuery.room && jsonQuery.room.value[0] ? RoomsLabel[jsonQuery.room.value[0]] : '';

  return {
    isSuccessModalOpen: demandShowSuccessModal(state),
    name: getName(firstName || '', lastName || ''),
    phone: user.isAuthenticated && user.phones ? (user.phones[0] || {}).phone : '',
    email: user.isAuthenticated ? user.email : '',
    displayName: (user && user.isAuthenticated && user.displayName) || undefined,
    isAuthenticated: Boolean(user && user.isAuthenticated),
    isHomeOwner: state.isHomeOwner,
    realtyCategory,
    publicProfile: Boolean(user.isAuthenticated && user.publicProfile),
    jsonQuery,
    realtyType,
    roomCount,
    bannerLocation: getBannerLocation(offers.length, offersPerPage, suggestions),
    dealType,
    region: getCity(currentLocation),
    userGADataLayerData: state.userGADataLayerData,
    deviceType: state.deviceType,
    soprApi,
    currentPageNumber: state.filters.jsonQuery.page ? state.filters.jsonQuery.page.value : 1,
    currentResultPageNumber: resultJsonQuery && resultJsonQuery.page ? resultJsonQuery.page.value : 1,
    queryString: state.results.queryString,
    observerKey: state.results.queryString,
    position: offers.length + (suggestions ? suggestions.length : 0) + 1,
  };
};

export const actions: TActions = {
  demandRequestCreateMessageStartAction,
  demandCloseSuccessModalAction,
};

// После переопределения Trap из функционального компонента в класс, ts решил, что offerId может быть undefined
// Нигде в проекте offerId не может быть undefined, такого тайпинга вообще нет, источник проблемы не нашли
// @ts-ignore
export const TrapContainer = connect(mapStateToProps, actions)(Trap);

export const transformTrapProps = (props: ITrapProps) => ({
  soprApi: props.soprApi || '',
  user_id: (props.userGADataLayerData && props.userGADataLayerData.realtyUserId) || null,
  pagenumber: props.currentResultPageNumber || 1,
  position: props.position || 1,
  pageType: 'Listing',
  device_type: props.deviceType || '',
  ab_group: (props.userGADataLayerData && props.userGADataLayerData.abGroup) || null,
  block_type: 'demand',
  sc: props.queryString || '',
});

export const getTeaserProps = ({ props, isViewed }: { props: ITrapProps; isViewed: boolean }): ITeaserEventProps => ({
  ...transformTrapProps(props),
  isTeaserShow: isViewed ? 1 : 0,
});

export const observerOptions = {
  onChange: (events: Array<{ props: ITrapProps; isViewed: boolean }>) => sendTeaserEvent(events.map(getTeaserProps)),
};

export const ObservableTrapContainer = connect(
  mapStateToProps,
  actions,
)(withObservation<ITrapProps>(Trap, observerOptions));
